import {Progress} from "@heroui/progress";
import {calculateVideoSize2, isDev} from "@/components/DownloaderApp/utils";
import React, {useState, useEffect} from "react";
import {Button} from "@heroui/button";
import {Link} from "@heroui/link";
import {LiveChip} from "@/components/DownloaderApp/LiveChip";
import {Popover, PopoverContent, PopoverTrigger} from "@heroui/popover";
import {SUPPORT_EMAIL} from "@/utils/email";
import SubOnlyContentAvailable, {getSubsOnlyVodsByChannel} from "@/components/DownloaderApp/SubOnlyContentAvailable";
import {usePremium} from "@/components/DownloaderApp/usePremium";
import {CopyIcon} from "@/components/DownloaderApp/icons";

export function FinalizingMessage() {
    const [showExtraText, setShowExtraText] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowExtraText(true);
        }, 6_000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <span>
            File downloaded, <b>
                <span style={{color: showExtraText ? '' : '#51FC1A'}} className={"inline-block text-center"}>
                    finalizing...
                    {showExtraText && <span style={{color: '#51FC1A'}}>{' '}it can take a while, really...</span>}
                </span>

            </b>

        </span>
    );
}


const COPY_OPTIONS = ["bits", "chunks", "pieces", "portions", "video segments", "scenes", "fragments", "slices"]
const COPY = COPY_OPTIONS[randomInRange(0, COPY_OPTIONS.length - 1)];


export function ProgressBar({progress, video, estimated, buyMeCoffeeButton, emitter}) {

    const [isFinishButtonLoading, setIsFinishButtonLoading] = useState(false)
    const [hasPremiumContent, setHasPremiumContent] = useState(false)
    const {details, hasPremium} = usePremium();

    const isWaitingForLiveSegments = video?.isLive && progress === 100
    const isIndeterminate = progress === 0 || isWaitingForLiveSegments || typeof progress === 'string'

    useEffect(() => {
        const shouldCheckSubOnlyContent = details === null && !!video && video.type === 'vod' && video.platform === 'kick' && !!video.slug
        if (shouldCheckSubOnlyContent) {
            getSubsOnlyVodsByChannel(video.slug).then(subsOnlyContent => {
                setHasPremiumContent(subsOnlyContent.length > 0)
            }).catch(err => console.error(err));
        } else {
        }
    }, [video, details]);


    const [startFrom] = useState(randomInRange(10, 70))

    const [emailCopied, setEmailCopied] = useState(false)

    const onCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(SUPPORT_EMAIL)
            setEmailCopied(true)
            setTimeout(() => setEmailCopied(false), 2000)
        } catch (e) {
            // clipboard not available
        }
    }

    const progressLabel = <>
        {typeof progress === 'string' ? <span>{progress}</span> : null}
        {progress === null ? <span>Initializing... (It takes a few seconds)</span> : null}
        {progress === 0 ? <><span>Loading first </span> <span
            style={{color: '#51FC1A'}}>{COPY}...</span></> : null}
        {isWaitingForLiveSegments ? <div className={"flex flex-row gap-1 w-full "}>
            <span className={""}>Waiting for new segments...</span>

        </div> : null}
        {!video?.isLive && progress === 100 ? <FinalizingMessage/> : null}

        {progress > 0 && progress < 100 ? <>
            <span><span>Downloading</span>{video?.isLive ? <span style={{color: '#51FC1A'}}>{' live stream'}</span> : null}<span>, </span><b><span
                style={{color: '#51FC1A'}}
                className={"inline-block text-center min-w-[70px]"}>{`${progress.toFixed(2)}%`}</span><span>{estimated ? ` of ${calculateVideoSize2(estimated)}` : ''}</span>{video?.isLive ?
                <span style={{color: '#51FC1A'}}>+</span> : null}<span> done</span></b></span>
        </> : null}
    </>

    function onPressed() {
        setIsFinishButtonLoading(true)
        emitter.emit("conclude")
    }

    const deviceSpaceNotVisible = !!estimated && !hasPremiumContent;

    const shouldRenderBuyMeCoffee = !hasPremium;

    return (
        <div className={"flex flex-col py-8 text-center gap-2 ph-no-capture"}>
            {video?.isLive && <LiveChip classNames={{base: "self-center"}}/>}
            <div className={"flex flex-col gap-3 min-h-[85px] "}>
                <Progress isIndeterminate={isIndeterminate}
                          classNames={{indicator: "bg-linear-to-r from-yellow-400 to-yellow-200"}}
                          isStriped={isIndeterminate} label={progressLabel} size="lg" aria-label="Loading..."
                          color={video?.isLive ? "danger" : "primary"}
                          value={progress}/>
                <div className={"min-h-8"}>
                    {isWaitingForLiveSegments ?
                        <div><Button isLoading={isFinishButtonLoading} className={""} color="primary" size="sm"
                                     onPress={onPressed}><span>Finish downloading</span></Button></div> :
                        <>
                            {deviceSpaceNotVisible ?
                                <span className={"text-center text-sm font-light flex justify-center gap-1"}>Questions?
                                    {/*<b className={"font-bold hidden"}>it's ~ {calculateVideoSize2(estimated)}</b>*/}
                                    {/*<Link isExternal showAnchorIcon className={"text-sm"} href={`https://tally.so/r/w42pbr?form_id=${window.posthog?.get_distinct_id?.() || "kvd"}`}>Share feedback</Link>*/}
                                    <Popover shouldCloseOnScroll shouldCloseOnBlur showArrow placement="right"
                                             color={"foreground"}>
                                          <PopoverTrigger>
                                              {/*https://tally.so/r/w42pbr?form_id=${window.posthog?.get_distinct_id?.() || "kvd"}*/}
                                                  <Link className={"text-sm cursor-pointer"}>Send us a message!</Link>
                                          </PopoverTrigger>
                                          <PopoverContent>
                                            <div className="px-1 py-2">
                                              <div className="text-small font-bold">Email address:</div>
                                                <div className="flex items-center gap-2 mt-1 flex-col">
                                                  <div className="text-tiny">{SUPPORT_EMAIL}</div>
                                                  <Button fullWidth size="sm" variant="flat" color="secondary"
                                                          className="h-6 min-w-0 px-2 text-tiny"
                                                          startContent={!emailCopied && <CopyIcon />}
                                                          onPress={onCopyEmail}>
                                                    <span>{emailCopied ? "Copied! ✅" : "Copy"}</span>
                                                  </Button>
                                                </div>
                                            </div>
                                          </PopoverContent>
                                        </Popover>
                                </span> : null}
                        </>}
                </div>
            </div>
            {shouldRenderBuyMeCoffee && <div
                className={`${progress > startFrom ? 'animate-fade-in' : 'hidden'} flex justify-center pt-8`}>
                {buyMeCoffeeButton}
            </div>}
            {/*{hasPremiumContent && <SubOnlyContentAvailable channelSlug={video.slug}/>}*/}
            {video && progress > 0 && video.platform === 'kick' && (
                <div className={"mt-6"}>
                    <Button color={"primary"} className={"text-sm"} onClick={() => window.open(`/channel/${video?.slug}`)}>
                        See hidden VODs from
                    <span className={"font-bold"}>@{video?.slug}</span>
                    </Button>
                </div>
            )}
        </div>
    )
}

export function randomInRange(start, stop) {
    return Math.floor(Math.random() * (stop - start + 1)) + start;
}
